interface LocalizedCardCopy {
  title: string
  description: string
}

interface IndexCardCopy {
  voice: LocalizedCardCopy
  audioTrim: LocalizedCardCopy
  circle: LocalizedCardCopy
}

export function buildIndexCards<Route extends { routeKey: string }>(
  registry: readonly Route[],
  copy: IndexCardCopy,
) {
  return registry.map((route) => {
    const localized = route.routeKey === 'voice-recorder'
      ? copy.voice
      : route.routeKey === 'audio-trimmer'
        ? copy.audioTrim
        : copy.circle
    const icon = route.routeKey === 'voice-recorder' ? '●' : route.routeKey === 'audio-trimmer' ? '✂' : '◉'
    return { route, icon, title: localized.title, detail: localized.description }
  })
}
